import React from "react";

import "./Logo.css";

const logo = props => <h1 className="logo">Shop Control</h1>;

export default logo;
